import React from 'react';
import CallVBACenter from 'platform/static-data/CallVBACenter';

export default function ErrorText() {
  return (
    <p>
      If it still doesn’t work, please <CallVBACenter />
    </p>
  );
}
